import { MediaSelect } from "@/(admin)/modules/media/pages/SelectMediaUIBuilder"
import { ComponentConfig } from "@measured/puck"
import { ContactProps, RenderConfig } from "./RenderConfig"

export const CaoCaoFAQs: ComponentConfig<ContactProps> = {
  label: "CaoCao | FAQs",
  //@ts-ignore
  fields: {
    contactLabel: {
      label: "Contact Label",
      type: "text",
    },
    contactInfo: {
      label: "Contact Info",
      type: "array",
      arrayFields: {
        iconUrl: {
          label: "Icon URL",
          type: "custom",
          render: props => <MediaSelect {...props} mediaType="image" />,
        },
        linkContact: {
          label: "Link Contact",
          type: "text",
        },
      },
    },
    faqs: {
      label: "FAQs",
      type: "array",
      arrayFields: {
        question: {
          label: "Question",
          type: "text",
        },
        answer: {
          label: "Answer",
          type: "textarea",
        },
      },
    },
    className: {
      label: "Class Name",
      type: "text",
    },
  },
  defaultProps: {
    contactLabel: "Liên hệ chuyên gia",
    contactInfo: [],
    faqs: [
      {
        question: "Xe sẽ được trả trong bao lâu?",
        answer:
          "It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters.",
      },
      {
        question: "Xe sẽ được trả trong bao lâu?",
        answer:
          "It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters.",
      },
    ],
    className: "",
  },
  ...RenderConfig,
}
